export default [
  {
    path: '/zjd/welfare', // 保险福利、福利计划
    name: 'welfare',
    component: () => {
      return import(
        /* webpackChunkName: "welfare" */ '@/views/welfare/index.vue'
      )
    }
  },
  {
    path: '/zjd/welfareDetail', // 福利详情
    name: 'welfareDetail',
    meta: {
      title: '共享福利'
    },
    component: () => {
      return import(
        /* webpackChunkName: "welfare" */ '@/views/welfare/welfareDetail.vue'
      )
    }
  },
  {
    path: '/zjd/insureDuty', // 保险责任
    name: 'insureDuty',
    component: () => {
      return import(
        /* webpackChunkName: "welfare" */ '@/views/welfare/insureDuty.vue'
      )
    }
  },
  {
    path: '/zjd/previewpdf', // pdf预览
    name: 'previewpdf',
    component: () => {
      return import(
        /* webpackChunkName: "welfare" */ '@/views/welfare/previewpdf.vue'
      )
    }
  }
]
